import { AccountType } from '@safc/api-client';
import type { IconKey } from 'assets/Icon.js';

const AccountTypeToIcon: Record<AccountType, IconKey | undefined> = {
  [AccountType.airTransportProviderHoldingAccount]:
    'accountsAirTransportProviderHAccountSvg',
  [AccountType.fuelProviderHoldingAccount]: 'accountsFuelProviderHAccountSvg',
  [AccountType.logisticsProviderHoldingAccount]:
    'accountsLogisticsProviderHAccountSvg',
  [AccountType.generalHoldingAccount]: 'accountsGeneralHoldingSvg',
} as const;

export const getAccountIcon = (
  accountType: AccountType,
): IconKey | undefined => {
  return AccountTypeToIcon[accountType];
};
